import axios from "axios";

//const url = "http://localhost:3004";
//const GENRES_ENDPOINT = "loginGegevens";

export const getLogingegevensAsync = async () => {
  //return axios.get(`${url}/${GENRES_ENDPOINT}`);
  return axios.get(`https://www.marchouben.nl/php/inloggegevens-get.php`);
};
